import { render, staticRenderFns } from "./TeacherScheduleTimeline.vue?vue&type=template&id=b989b05a&scoped=true&"
import script from "./TeacherScheduleTimeline.vue?vue&type=script&lang=js&"
export * from "./TeacherScheduleTimeline.vue?vue&type=script&lang=js&"
import style0 from "./TeacherScheduleTimeline.vue?vue&type=style&index=0&id=b989b05a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b989b05a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VBtn,VIcon,VTimeline,VTimelineItem})
